export default {
      id: "car-usage",
      viewBox: "0 0 42 42",
      url: __webpack_public_path__ + "sprite.svg#car",
      toString: function () {
        return this.url;
      }
    }